export const POST_UPLOADS = "postUploads"
export const POST_ATTACHMENTS = "postAttachments"